exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media only screen and (max-width:768px) {\r\n    .view-card-product{\r\n        padding-top: 50px;\r\n    }\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// G:/MyProjects/Angular/oshop/src/app/admin/product-form/product-form.component.css
// module id = ../../../../../src/app/admin/product-form/product-form.component.css
// module chunks = main